import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-288fff94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm_btn" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonConfirm',
  props: {
  disable: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('MODAL__ALERT_MSG__BUTTON')), 1)
  ]))
}
}

})